function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Form from 'react-jsonschema-form';
import StaticForm from '../StaticForm/StaticForm';
import UniqueFormIdContext from './UniqueFormIdContext';
import ValidateDirtyOnlyContext from './ValidateDirtyOnlyContext';
import ValidateErrorsContext from './ValidateErrorsContext';
import ValidateFocusFirstErrorContext from './ValidateFocusFirstErrorContext';
import ValidateOnBlurContext from './ValidateOnBlurContext';
import validateFormData from 'react-jsonschema-form/lib/validate';
import { focusFirstErrorField } from './validationFormUtils';
import uuid from '../../utils/uuid';
var FocusErrorForm = function FocusErrorForm(_ref) {
  var submitRef = _ref.submitRef,
    uiSchema = _ref.uiSchema,
    formId = _ref.formId,
    rest = _objectWithoutProperties(_ref, ["submitRef", "uiSchema", "formId"]);
  var focusFirstError = useContext(ValidateFocusFirstErrorContext);
  var formErrors = useContext(ValidateErrorsContext);
  useEffect(function () {
    if (focusFirstError && formErrors.length) {
      focusFirstErrorField(uiSchema, formErrors, formId);
    }
  }, [focusFirstError, formErrors, uiSchema, formId]);
  return /*#__PURE__*/React.createElement(StaticForm, Object.assign({
    uiSchema: uiSchema
  }, rest), /*#__PURE__*/React.createElement("button", {
    ref: submitRef,
    style: {
      display: 'none'
    },
    type: "submit"
  }, "submit"));
};

// Form.validate is recreating a new schema every time any of our dates change.
// This causes a ~1s delay when tabbing through dates as AJV caches a validator
// based on the supplied schema. I removed this always so that the same schema
// is always used to keep the validation cached. According to the rjsf git blame
// this could cause duplicate errors. I have tested and cannot reproduce this
// with our schemas.
//
// see https://github.com/rjsf-team/react-jsonschema-form/blob/v1.8.1/src/components/Form.js#L98
var ExtendedForm = /*#__PURE__*/function (_Form) {
  _inherits(ExtendedForm, _Form);
  function ExtendedForm() {
    _classCallCheck(this, ExtendedForm);
    return _possibleConstructorReturn(this, _getPrototypeOf(ExtendedForm).apply(this, arguments));
  }
  _createClass(ExtendedForm, [{
    key: "validate",
    value: function validate(formData) {
      var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.schema;
      var additionalMetaSchemas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.additionalMetaSchemas;
      var customFormats = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props.customFormats;
      var _this$props = this.props,
        validate = _this$props.validate,
        transformErrors = _this$props.transformErrors;
      return validateFormData(formData, schema, validate, transformErrors, additionalMetaSchemas, customFormats);
    }
  }]);
  return ExtendedForm;
}(Form);
export default function ValidationForm(props) {
  var _props$liveValidate = props.liveValidate,
    liveValidate = _props$liveValidate === void 0 ? false : _props$liveValidate,
    onChange = props.onChange,
    onError = props.onError,
    onSubmit = props.onSubmit,
    onValidate = props.onValidate,
    submitRef = props.submitRef,
    _props$validateDirtyO = props.validateDirtyOnly,
    validateDirtyOnly = _props$validateDirtyO === void 0 ? true : _props$validateDirtyO;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var ref = useRef(null);
  var formRef = props.formRef || ref;
  var formId = useMemo(function () {
    return "-".concat(uuid());
  }, []);
  useEffect(function () {
    if (!validateDirtyOnly && formRef && formRef.current) {
      formRef.current.submit();
    }
  }, [validateDirtyOnly, formRef]);
  var handleWidgetBlur = useCallback(function () {
    if (formRef && formRef.current) {
      formRef.current.submit();
    }
  }, [formRef]);
  var handleChange = useCallback(function (formData) {
    if (onChange) {
      onChange(formData);
    }
    if (liveValidate && formRef && formRef.current) {
      formRef.current.submit();
    }
  }, [liveValidate, formRef, onChange]);
  var handleValidate = useCallback(function (isValid) {
    if (onValidate) {
      onValidate(isValid);
    }
  }, [onValidate]);
  var handleError = useCallback(function (p1) {
    handleValidate(false);
    setErrors(p1);
    if (onError) {
      onError(p1);
    }
  }, [handleValidate, onError]);
  var handleSubmit = useCallback(function (p1) {
    handleValidate(true);
    if (onSubmit) {
      onSubmit(p1);
    }
  }, [handleValidate, onSubmit]);
  return /*#__PURE__*/React.createElement(ValidateDirtyOnlyContext.Provider, {
    value: validateDirtyOnly
  }, /*#__PURE__*/React.createElement(ValidateOnBlurContext.Provider, {
    value: handleWidgetBlur
  }, /*#__PURE__*/React.createElement(ValidateErrorsContext.Provider, {
    value: errors
  }, /*#__PURE__*/React.createElement(UniqueFormIdContext.Provider, {
    value: formId
  }, /*#__PURE__*/React.createElement(FocusErrorForm, Object.assign({
    formRef: formRef,
    formId: formId,
    component: ExtendedForm,
    formNoValidate: true
  }, props, {
    onChange: handleChange,
    onError: handleError,
    onSubmit: handleSubmit,
    submitRef: submitRef
  }))))));
}